import React from 'react';
import { ResumeJourneyType } from './resumeJourney.type';
import styles from './resumeJourneyCard.module.scss';
import {
  PrimarySmallButton,
  Regular14,
  SemiBold16,
} from '@/components/design-system';
import Image from 'next/image';
import { classNames } from '@/core/utils/class.utils';
import { useRouter } from 'next/navigation';
import { INTERNAL_LOB } from '@/core/constants/policy.constants';

const ResumeJourneyCard = ({
  title,
  description,
  image,
  internalLob,
  route,
}: ResumeJourneyType) => {
  const router = useRouter();
  return (
    <>
      <div
        className={classNames(styles['main-con'], {
          [styles['health-bg']]: internalLob === INTERNAL_LOB.health,
        })}
      >
        {image && (
          <div className={styles['vehicle-image']}>
            <Image src={image} alt={'img'} width={85} height={46} />
          </div>
        )}
        <div className={styles['text-con']}>
          <SemiBold16>{title}</SemiBold16>
          <Regular14>{description}</Regular14>
        </div>

        <PrimarySmallButton
          color="var(--primary-midnight)"
          onClick={() => {
            if (route) {
              router.push(route);
            }
          }}
        >
          {'Continue'}
        </PrimarySmallButton>
      </div>
      <div
        className={classNames(styles['mobile-view'], {
          [styles['health-bg']]: internalLob === INTERNAL_LOB.health,
        })}
      >
        <div className={styles['text-con']}>
          <SemiBold16>{title}</SemiBold16>
          <div className={styles['desc-con']}>
            <Regular14>{description}</Regular14>
          </div>
        </div>
        <PrimarySmallButton
          color="var(--primary-midnight)"
          onClick={() => {
            if (route) {
              router.push(route);
            }
          }}
        >
          {'Continue'}
        </PrimarySmallButton>
        <div className={styles['image']}>
          <Image width={65} height={65} src={image} alt={'img'} />
        </div>
      </div>
    </>
  );
};

export default ResumeJourneyCard;
